import React from 'react'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'

const EsccValidationListUI = ({ context, esccValidationList, onRefreshClick, onValidateClick }) =>
  <div className='su_escc'>
  <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <span className='g_large'><b>ESCC Account Validation Status</b></span>
        </div>
      }
      right={<span />}
    />
    <LRTableBodyUI>
      {
        esccValidationList.map((account, i) =>
          <LRTableRowUI key={i} context={context}
            left={
              <div className='g_flex_v'>
                <b>{account.accountName}</b>
                <span className='g_muted g_small'>{account.accountId}</span>
                <span className='g_muted g_small'>{account.bankAccountNumber}</span>
              </div>
            }
    right={
              <div className='g_flex_h' style={{ alignItems: 'center' }}>
                <div style={{ width: '90px' }}>
                  <BadgeUI label={account.esccValidationStatus === 'validated' ? 'validated' : 'in progress'} />
                </div>
                <div style={{ width: '90px' }}>
                  {
                    account.esccValidationStatus !== 'validated' &&
                    <ButtonTinyUI label='Validate' rowId={account.bankAccountNumber} onClick={onValidateClick} />
                  }
                </div>
              </div>
            }
          />
        )
      }
    </LRTableBodyUI>
  </div>

export default EsccValidationListUI